import {ChangeDetectorRef,Component,ElementRef,OnInit,ViewChild, OnDestroy} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil} from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-bc-tt-ht-gdhn',
  templateUrl: './bc-tt-ht-gdhn.component.html',
  styleUrls: ['./bc-tt-ht-gdhn.component.scss']
})
export class BcTtHtGdhnComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private authQuery: AuthQuery,
    public utilService: UtilsService,
    private service: BaocaoService,
    private disTypeOfSchoolsService: TypeOfSchoolService,
  ) {}
  get breadcrumbs(): string[] {
    return ['Báo cáo tổng hợp'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  thongtinCSGDList: any;
  ListCapHoc: any[] = [];
  ListLoaiHinh: any[] = [];
  ListDieuKien: any[] = [];
  firstRowOnPage: any;
  dataList: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  getProvinceACFn: (value: any) => Observable<any>;
  ProvinceSubscription: any;
  ProvinceControl = new FormControl();
  @ViewChild('pageSample8', { static: false }) elementPageSample8: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  $unSubscribe= new Subject();
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  getDisTypeOfSchoolsACFn: (value: any) => Observable<any>;
  disTypeOfSchoolsSubscription: any;
  disTypeOfSchoolsControl = new FormControl();
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.loadDisTypeOfSchools();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe(() => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });

  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.thongtinCSGDList = [];
    this.service.GetReportCsgdInfo(this.commonFilter)
    .pipe(takeUntil(this.$unSubscribe)).subscribe(
      (response: any) => {
        if (response.data){
          const total = response.pivotCh.chOrder;
          const list = response.data ? response.data : [];
          this.Total = (response && response.rowCount) ? response.rowCount : 0;
          this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
          _this.thongtinCSGDList = (list) ? list : [];
        }
        if (response){
          this.ListCapHoc = response.pivotCh;
          this.ListLoaiHinh = response.pivotLh;
          this.ListDieuKien = response.pivotDk;
        }else{
          this.ListCapHoc = [];
        }
        _this.loading = false;
      },
      (err: any) => {
        _this.thongtinCSGDList = [];
        _this.loading = false;
      }
    );
  }
  exportExcel(){
    // document.getElementById('btnvF').click();
      this.service.exportRpCsgdTksl(this.commonFilter).subscribe((data:any) => {
        const downloadURL = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'tthtgdhn.xlsx';
        link.click();
      });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    // this.width = window.innerWidth;
    this.checkCaculateHeight(this.isCollapse);
    this.width = this.widthfnc();
    setTimeout(() => {
      this.reload();
      this.tableElement.scrollX = 1500 + 'px';
    }, 100);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => console.log('alt + n')
      ,
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  loadDisTypeOfSchools() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfSchoolsACFn = (value: any) => this.disTypeOfSchoolsService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfSchoolName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfSchoolsSubscription) { this.disTypeOfSchoolsSubscription = this.disTypeOfSchoolsControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'disTypeOfSchoolsId', this.disTypeOfSchoolsControl.value);
    });
    }
  }
  changeDisTypeOfSchools(control: FormControl) {
    this.disTypeOfSchoolsControl = control;
  }

  clear(){
    this.commonFilter.SearchTerm = '';
    this.disTypeOfSchoolsControl.setValue(null);
    this.reload();
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}
}
